import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: "renamingTitle" }
const _hoisted_2 = {
  type: "submit",
  class: "c-button c-button--no-ellipsis ml-10 w-90 md:min-w-120 md:ml-20"
}
const _hoisted_3 = { class: "c-magic-line" }
const _hoisted_4 = { key: "staticTitle" }
const _hoisted_5 = { class: "truncate block w-full md:mr-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createBlock(_Transition, {
    name: "o-anim-fade-300",
    mode: "out-in"
  }, {
    default: _withCtx(() => [
      (_ctx.titleIsBeingRenamed)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_Form, {
              "validation-schema": _ctx.validation,
              class: "flex flex-row items-center flex-nowrap md:pb-1 xl:pb-12",
              onSubmit: _ctx.submitRenamedTitle
            }, {
              default: _withCtx(() => [
                _createVNode(_component_InputText, {
                  name: "editTitle",
                  class: "o-text-h3 flex-grow md:pt-0 md:-mt-1 md:flex-grow-0",
                  value: _ctx.title,
                  autofocus: true,
                  "show-errors": false,
                  "input-clear": false
                }, null, 8, ["value"]),
                _createElementVNode("button", _hoisted_2, _toDisplayString(_ctx.labels.saveListName), 1),
                _createElementVNode("button", {
                  class: "ml-10 mx-auto text-dusty-grey w-90 md:w-auto md:ml-20",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)), ["prevent"]))
                }, [
                  _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.labels.cancelDeleteBtn), 1)
                ])
              ]),
              _: 1
            }, 8, ["validation-schema", "onSubmit"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.title), 1)
          ]))
    ]),
    _: 1
  }))
}